import { render, staticRenderFns } from "./CmaAsset3dView.vue?vue&type=template&id=70394750&scoped=true&"
import script from "./CmaAsset3dView.vue?vue&type=script&lang=js&"
export * from "./CmaAsset3dView.vue?vue&type=script&lang=js&"
import style0 from "./CmaAsset3dView.vue?vue&type=style&index=0&id=70394750&scoped=true&lang=css&"
import style1 from "./CmaAsset3dView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70394750",
  null
  
)

export default component.exports